// Tab session helpers that need both tab + navigation modules.
import { state, active, byId } from "./state.js";
import { newTab, openInternal } from "./tabs.js";
import { navigateTab } from "./navigation.js";
import { openFolder, openLocalBook } from "./folders.js";
import { render } from "./view.js";
import { get } from "../shared/settings-store.js";

function reopen(spec) {
	if (!spec) { newTab(); return; }
	// A library title goes through the same isolation check as opening it from Books.
	if (spec.internal && String(spec.internal).startsWith("/books/")) { openLocalBook({ url: spec.internal, name: spec.title }); return; }
	if (spec.internal) { openInternal(spec.internal, spec.title); return; }
	if (spec.url) { const id = newTab(); navigateTab(id, spec.url); return; }
	if (spec.view) { newTab(); openFolder(spec.view); return; }
	newTab();
}

export function reopenClosed() {
	if (!state.closed.length) return;
	reopen(state.closed.pop());
}

export function duplicateActive() {
	const t = active();
	reopen(t ? { url: t.url, internal: t.internal, view: t.view, title: t.title } : null);
}

// A user-initiated new tab that honors the "New tab shows" setting.
export function newTabAction() {
	const mode = get("newTab");
	const home = get("newTabUrl");
	if (mode === "url" && home) { const id = newTab(); navigateTab(id, home); return id; }
	const id = newTab();
	if (mode === "blank") { const t = byId(id); if (t) { t.blank = true; render(); } }
	return id;
}

export function openHome() {
	const home = get("homepage");
	if (home) { const id = newTab(); navigateTab(id, home); }
	else newTab();
}
